module.exports = __webpack_public_path__ + "static/img/contextual-recruitment-research-MAC.ba32d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/contextual-recruitment-research-MAC.png
// module id = TLDK
// module chunks = 0